$(document).ready(function () {

    var locationPage = document.location.pathname;



    $('.application-form__block-info *').hide();
    $('#showStatementForm').on('click', function (e) {
        e.preventDefault();
        $('#statementForm').show();
        $('#upload_document').show();

        if (locationPage == '/customer_service/insurance_case/') {
            $('a.download-blank-link').show();
        }

        $('#form_send_declaration').show();
        $('.statement-first-screen').hide();
        //$('.statement-first-screen__dd-block').hide();
    });


    $('.fsi-dropdown__item').on('click', function () {
        console.log('click ok');
        $(this).closest('.fbm-step-item__input_dropdown').find('.fsi-dropdown__item').attr('data-checked', '0');
        $(this).attr('data-checked', '1');

        $(this).closest('.fbm-step-item__input_field').find('.fbmit_selected_value').val($(this).text());
        $(this).closest('.fbm-step-item__input_field').parent().find('.fbm-step-item__input_title label').show();

        //скрыть/показать блок с дальнейшими шагами

        switch (locationPage) {
            case '/customer_service/application_forms/':
            {
                //если был выбран опшен из селекта Программа,
                // то надо скрыть все опшены селекта Причина,
                // и вывести только те которые принадлежат этой программе
                if ($(this).closest('.select-program').length > 0) {
                    $('.select-reason .fsi-dropdown__item').hide();
                    $('.select-reason .fsi-dropdown__item').attr('data-checked', '0');
                    $('.select-reason #fbmit_reason').val('');
                    $('.select-reason .fsi-dropdown__item[data-program-ids=' + $(this).attr('data-item-id') + ']').show();

                    // добавляем атрибут для поиска только по пунктам относящимся к выбранной программе
                    $('.select-reason .fsi-dropdown__item[data-program-ids=' + $(this).attr('data-item-id') + ']').attr('data-search-in', 1);
                    $('.select-reason .fsi-dropdown__item:not([data-program-ids=' + $(this).attr('data-item-id') + '])').attr('data-search-in', 0);

                    var _this = $(this);
                    $('.select-reason .fsi-dropdown__item').each(function () {
                        if ($(this).attr('data-program-ids').split(',').indexOf(_this.attr('data-item-id')) !== -1) {
                            $(this).show();
                        }
                    });
                    reason = null;
                    pathFile = [];
                    $('#upload_document').hide();

                } else {
                    var programOptionEl = $('.select-program .fsi-dropdown__item[data-checked="1"]'),
                            reasonOptionEl = $('.select-reason .fsi-dropdown__item[data-checked="1"]');
                    if (programOptionEl.length > 0 && reasonOptionEl.length > 0) {
                        var reasonChecked = reasonOptionEl.attr('data-item-id');
                        $('#upload_document a.download-blank-link').hide();
                        resultClose.trigger('click');
                        $('a.download-blank-link').each(function () {
                            if ($(this).attr('data-reason-ids').split(',').indexOf(reasonChecked) !== -1) {
                                $(this).show();
                                $('#upload_document').show();
                                $('.application-form__block-info *').show();
                            }
                        });

                        if ($('a.download-blank-link :visible').length < 1) {
                            $('#upload_document').hide();
                        }
                    } else {
                        $('#upload_document').hide();
                    }
                }


                break;
            }
            case '/customer_service/insurance_case/':
            {
                var insuranceCaseOptionEl = $('.select-insurance_case .fsi-dropdown__item[data-checked="1"]');
                if (insuranceCaseOptionEl.length > 0) {
                    var insuranceCaseChecked = insuranceCaseOptionEl.attr('data-item-id');
                    $('#upload_document').show();
                    $('a.download-blank-link').each(function () {
                        if ($(this).attr('data-insurance-cases-ids').split(',').indexOf(insuranceCaseChecked) !== -1) {
                            $(this).show();
                            $('#upload_document').show();
                        } else {
                            $(this).hide();
                        }
                    });
                } else {
                    $('#upload_document').hide();
                }
                break;
            }
            case '/customer_service/edit_data/':
            {
                var editDataOptionEl = $('.select-edit_contract .fsi-dropdown__item[data-checked="1"]');
                if (editDataOptionEl.length > 0) {
                    var editDataChecked = editDataOptionEl.attr('data-item-id');
                    $('#upload_document').show();
                    $('.fbm-step-item__warn').css('display', 'flex');
                    $('a.download-blank-link').each(function () {
                        if ($(this).attr('data-edit-contract-ids').split(',').indexOf(editDataChecked) !== -1) {
                            $(this).show();
                            $('#upload_document').show();
                        } else {
                            $(this).hide();
                        }
                    });
                } else {
                    $('#upload_document').hide();
                }
                break;
            }
            case '/customer_service/contract_payment/':
            {
                var docDataOptionEl = $('.select-doc .fsi-dropdown__item[data-checked="1"]');
                console.log(docDataOptionEl);
                if (docDataOptionEl.length > 0) {
                    console.log(docDataOptionEl.attr('data-item-id'));
                    switch (+docDataOptionEl.attr('data-item-id')) {
                        case 1:
                        {
                            $('#fbmit_serial').mask("99 99 999999");
                            break;
                        }
                        case 2:
                        {
                            $('#fbmit_serial').mask("************");
                            break;
                        }
                    }

                }
                break;
            }
            default:
            {
                console.log('unknown page');
            }
        }
    });

    $('input[name="payment_value"').on('input', function () {
        $(this).val(accounting.formatMoney($(this).val(), "", " ", " "));
    });

    $('.fbmit_selected_value').on('input', function () {
        var _this = this;
        $(this).parent().addClass('dd-opened');

        // Для причин ищем только в тех которые относятся к выбранной программе
        if ($(_this).attr('id') == 'fbmit_reason') {
            if ($(_this).val() === '') {
                $(_this).closest('.fbm-step-item__input_field').find('.fsi-dropdown__item[data-search-in="1"]').attr('data-checked', '0');
            }
            $(_this).closest('.fbm-step-item__input_field').find('.fsi-dropdown__item[data-search-in="1"]').each(function () {
                if ($(this).text().toLowerCase().indexOf($(_this).val().toLowerCase()) !== -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        } else {
            if ($(_this).val() === '') {
                $(_this).closest('.fbm-step-item__input_field').find('.fsi-dropdown__item').attr('data-checked', '0');
            }
            $(_this).closest('.fbm-step-item__input_field').find('.fsi-dropdown__item').each(function () {
                if ($(this).text().toLowerCase().indexOf($(_this).val().toLowerCase()) !== -1) {
                    $(this).show();
                } else {
                    $(this).hide();
                }
            });
        }
    });

    $('.fbm-step-item__input_field').on('click', function () {
        var selectedOptionEl = $(this).find('.fsi-dropdown__item[data-checked="1"]');
        //toggle border-bottom
        $(this).find('input').toggleClass('input-active');
        if (selectedOptionEl.length > 0) {
            $(this).find('input.fbmit_selected_value').val(selectedOptionEl.text());
        }
    });

    // show/hide svg for validation
    $('.fbm-step-item__input .data-input').blur(function () {
        console.log('blur');
        if (/^[ \-+()0-9а-яА-ЯёЁ\s]+$/.test($(this).val()) && $(this).val().trim().length > 1) {
            $(this).closest('.fbm-step-item__input').find('.input-correct').show();
            $(this).closest('.fbm-step-item__input').find('.fbm-step-item__input_field__error').hide();
        } else {
            $(this).closest('.fbm-step-item__input').find('.input-correct').hide();
            $(this).closest('.fbm-step-item__input').find('.fbm-step-item__input_field__error').show();
        }
    });

    /* FBM ALH Switcher */
    $(document).on('click', '#fbm-step-switcher .alh-switcher__item', function () {
        var showId = $(this).attr('data-doc-id');
        var hideId = $('#fbm-step-switcher .alh-switcher__item-active').attr('data-doc-id');

        $('#fbm-step-switcher .alh-switcher__item-active').removeClass('alh-switcher__item-active');
        $(this).addClass('alh-switcher__item-active');

        $('.fbm-step__download-blank_desktop[data-doc="' + hideId + '"]').hide();
        $('.fbm-step__download-blank_desktop[data-doc="' + showId + '"]').show();

        $('.rb_' + hideId).removeAttr('id');
        $('.rb_' + showId).attr('id', 'result_block');

        $('.doc_text_' + hideId).hide();
        $('.doc_text_' + showId).show();
    });

    /* Accordion ALH Switcher */
    $(document).on('click', '#accordion-switcher .alh-switcher__item', function () {
        var showId = $(this).attr('data-al-list-id');
        var hideId = $('#accordion-switcher .alh-switcher__item-active').attr('data-al-list-id');

        $('#accordion-switcher .alh-switcher__item-active').removeClass('alh-switcher__item-active');
        $(this).addClass('alh-switcher__item-active');

        $('.accordion-list__info[data-al-list="' + hideId + '"]').hide();
        $('.accordion-list__info[data-al-list="' + showId + '"]').show();
    });

    /** Upload file */
    var uploadAreaInput = $('.upload-blank-area__input'),
            uploadAreaResult = $('.upload-blank-area__result'),
            textPercentProgress = $('.text-percent-progress'),
            svgProgress = $('.svg-progress'),
            resultClose = $('.resultclose'),
            uploadInputFile = $('#upload-blank-input-file'),
            uploadFileInput = $('#uploadfileinput-js'),
            inputChangePhone = $('.sms-check__phone-change input');

    var uploadAreaInputPhoto = $('.upload-blank-area__input-photo'),
            uploadAreaResultPhoto = $('.upload-blank-area__result-photo'),
            textPercentProgressPhoto = $('.text-percent-progress-photo'),
            svgProgressPhoto = $('.svg-progress-photo'),
            resultClosePhoto = $('.resultclose-photo'),
            uploadInputFilePhoto = $('#upload-photo-input-file'),
            uploadFileInputPhoto = $('#uploadfileinputphoto-js');

    var uploadAreaInputSelfie = $('.upload-blank-area__input-selfie'),
            uploadAreaResultSelfie = $('.upload-blank-area__result-selfie'),
            textPercentProgressSelfie = $('.text-percent-progress-selfie'),
            svgProgressSelfie = $('.svg-progress-selfie'),
            resultCloseSelfie = $('.resultclose-selfie'),
            uploadInputFileSelfie = $('#upload-selfie-input-file'),
            uploadFileInputSelfie = $('#uploadfileinputselfie-js');

    var uploadAreaInputSpravka = $('.upload-blank-area__input-spravka'),
            uploadAreaResultSpravka = $('.upload-blank-area__result-spravka'),
            textPercentProgressSpravka = $('.text-percent-progress-spravkae'),
            svgProgressSpravka = $('.svg-progress-spravka'),
            resultCloseSpravka = $('.resultclose-spravka'),
            uploadInputFileSpravka = $('#upload-spravka-input-file'),
            uploadFileInputSpravka = $('#uploadfileinputspravka-js');
    // var alowedFileExt = ['doc', 'docx', 'pdf', 'png', 'jpg'];

    var pathFile = [], pathFilePhoto = [], pathFileSelfie = [], pathFileSpravka = [], fio = null, phone = null,
            // for application forms page
            reason = null, program = null,
            // for insurance case page
            insuranceCase = null,
            whatFace = null,
            // for edit data page
            change = null;

    uploadInputFile.on('change', function () {
        uploadInputFile[0].files.forEach(function (file) {
            fileUpload(file);
        });
    });

    uploadInputFilePhoto.on('change', function () {
        uploadInputFilePhoto[0].files.forEach(function (file) {
            fileUploadPhoto(file);
        });
        //fileUploadPhoto(uploadInputFilePhoto[0].files[0]);
    });

    uploadInputFileSelfie.on('change', function () {
        uploadInputFileSelfie[0].files.forEach(function (file) {
            fileUploadSelfie(file);
        });
    });
    uploadInputFileSpravka.on('change', function () {
        uploadInputFileSpravka[0].files.forEach(function (file) {
            fileUploadSpravka(file);
        });
    });

    function fileUpload(file) {
        var fileExt = file.name.split('.').pop();

        // if (alowedFileExt.indexOf(fileExt) == -1) {
        //     $('.input-error-file').text('Вы можете загрузить файлы формата: pdf, png, doc, docx, jpg');
        //     $('.input-error-file').show();
        //     return false;
        // }

        uploadAreaInput.hide();
        uploadAreaResult.fadeIn();

        var formData = new FormData();
        formData.append('file', file);

        svgProgress.addClass('progress-upload-run');
        console.log('file uploading...');
        $.ajax({
            url: '/local/scripts/save_file.php',
            type: 'POST',
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            xhr: function ()
            {
                var jqXHR = null;
                if (window.ActiveXObject)
                {
                    jqXHR = new window.ActiveXObject("Microsoft.XMLHTTP");
                } else
                {
                    jqXHR = new window.XMLHttpRequest();
                }

                //Upload progress
                jqXHR.upload.addEventListener("progress", function (evt)
                {
                    if (evt.lengthComputable)
                    {
                        var percentComplete = Math.round((evt.loaded * 100) / evt.total);
                        //Do something with upload progress
                        textPercentProgress.html(percentComplete + "%");
                        console.log('Uploaded percent', percentComplete);
                    }
                }, false);

                return jqXHR;
            },
            success: function (data)
            {
                console.log('Completed.', data);
                svgProgress.addClass('progress-upload-end');
                uploadAreaResult.addClass('ubares-done');
                $('.show-after-upload').show();

                if (data !== -1) {
                    pathFile.push(data);
                    var existedText = uploadAreaResult.find('.upload-filename').text();
                    if (existedText) {
                        existedText += (', ' + file.name);
                    } else {
                        existedText = file.name;
                    }
                    existedText = existedText.split(', ').filter(function (item) {
                        return item !== 'Загрузка';
                    }).join(', ');
                    uploadAreaResult.find('.upload-filename').text(existedText);
                } else {
                    uploadAreaResult.find('.upload-filename').text('Ошибка загрузки файла');
                }
            }
        });
    }

    function fileUploadPhoto(file) {
        var fileExt = file.name.split('.').pop();

        // if (!alowedFileExt.includes(fileExt)) {
        //     $('.input-error-photo').text('Вы можете загрузить файлы формата: pdf, png, doc, docx, jpg');
        //     $('.input-error-photo').show();
        //     return false;
        // }

        uploadAreaInputPhoto.hide();
        uploadAreaResultPhoto.fadeIn();

        var formData = new FormData();
        formData.append('file', file);

        svgProgressPhoto.addClass('progress-upload-run');
        console.log('photo uploading...');
        $.ajax({
            url: '/local/scripts/save_file.php',
            type: 'POST',
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            xhr: function () {
                var jqXHR = null;
                if (window.ActiveXObject) {
                    jqXHR = new window.ActiveXObject("Microsoft.XMLHTTP");
                } else {
                    jqXHR = new window.XMLHttpRequest();
                }

                //Upload progress
                jqXHR.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = Math.round((evt.loaded * 100) / evt.total);
                        //Do something with upload progress
                        textPercentProgressPhoto.html(percentComplete + "%");
                        console.log('Uploaded percent', percentComplete);
                    }
                }, false);

                return jqXHR;
            },
            success: function (data) {
                console.log('Completed.', data);
                svgProgressPhoto.addClass('progress-upload-end');
                uploadAreaResultPhoto.addClass('ubares-done');
                console.log('photo uploaded');
                if (data !== -1) {
                    pathFilePhoto.push(data);
                    var existedText = uploadAreaResultPhoto.find('.upload-filename').text();
                    if (existedText) {
                        existedText += (', ' + file.name);
                    } else {
                        existedText = file.name;
                    }
                    existedText = existedText.split(', ').filter(function (item) {
                        return item !== 'Загрузка';
                    }).join(', ');
                    uploadAreaResultPhoto.find('.upload-filename').text(existedText);

                } else {
                    uploadAreaResultPhoto.find('.upload-filename').text('Ошибка загрузки файла');
                }
            }
        });
    }

    function fileUploadSelfie(file) {
        var fileExt = file.name.split('.').pop();

        // if (!alowedFileExt.includes(fileExt)) {
        //     $('.input-error-selfie').text('Вы можете загрузить файлы формата: pdf, png, doc, docx, jpg');
        //     $('.input-error-selfie').show();
        //     return false;
        // }

        uploadAreaInputSelfie.hide();
        uploadAreaResultSelfie.fadeIn();

        var formData = new FormData();
        formData.append('file', file);

        svgProgressSelfie.addClass('progress-upload-run');
        console.log('photo uploading...');
        $.ajax({
            url: '/local/scripts/save_file.php',
            type: 'POST',
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            xhr: function () {
                var jqXHR = null;
                if (window.ActiveXObject) {
                    jqXHR = new window.ActiveXObject("Microsoft.XMLHTTP");
                } else {
                    jqXHR = new window.XMLHttpRequest();
                }

                //Upload progress
                jqXHR.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = Math.round((evt.loaded * 100) / evt.total);
                        //Do something with upload progress
                        textPercentProgressSelfie.html(percentComplete + "%");
                        console.log('Uploaded percent', percentComplete);
                    }
                }, false);

                return jqXHR;
            },
            success: function (data) {
                console.log('Completed.', data);
                svgProgressSelfie.addClass('progress-upload-end');
                uploadAreaResultSelfie.addClass('ubares-done');
                console.log('photo uploaded');
                if (data !== -1) {
                    pathFileSelfie.push(data);
                    var existedText = uploadAreaResultSelfie.find('.upload-filename').text();
                    if (existedText) {
                        existedText += (', ' + file.name);
                    } else {
                        existedText = file.name;
                    }
                    existedText = existedText.split(', ').filter(function (item) {
                        return item !== 'Загрузка';
                    }).join(', ');
                    uploadAreaResultSelfie.find('.upload-filename').text(existedText);
                } else {
                    uploadAreaResultSelfie.find('.upload-filename').text('Ошибка загрузки файла');
                }
            }
        });
    }

    function fileUploadSpravka(file) {
        var fileExt = file.name.split('.').pop();
        uploadAreaInputSpravka.hide();
        uploadAreaResultSpravka.fadeIn();

        var formData = new FormData();
        formData.append('file', file);

        svgProgressSelfie.addClass('progress-upload-run');
        console.log('photo uploading...');
        $.ajax({
            url: '/local/scripts/save_file.php',
            type: 'POST',
            contentType: false,
            cache: false,
            processData: false,
            data: formData,
            xhr: function () {
                var jqXHR = null;
                if (window.ActiveXObject) {
                    jqXHR = new window.ActiveXObject("Microsoft.XMLHTTP");
                } else {
                    jqXHR = new window.XMLHttpRequest();
                }

                //Upload progress
                jqXHR.upload.addEventListener("progress", function (evt) {
                    if (evt.lengthComputable) {
                        var percentComplete = Math.round((evt.loaded * 100) / evt.total);
                        //Do something with upload progress
                        textPercentProgressSpravka.html(percentComplete + "%");
                        console.log('Uploaded percent', percentComplete);
                    }
                }, false);

                return jqXHR;
            },
            success: function (data) {
                console.log('Completed.', data);
                svgProgressSpravka.addClass('progress-upload-end');
                uploadAreaResultSpravka.addClass('ubares-done');
                console.log('photo uploaded');
                if (data !== -1) {
                    pathFileSpravka.push(data);
                    var existedText = uploadAreaResultSpravka.find('.upload-filename').text();
                    if (existedText) {
                        existedText += (', ' + file.name);
                    } else {
                        existedText = file.name;
                    }
                    existedText = existedText.split(', ').filter(function (item) {
                        return item !== 'Загрузка';
                    }).join(', ');
                    uploadAreaResultSpravka.find('.upload-filename').text(existedText);
                } else {
                    uploadAreaResultSpravka.find('.upload-filename').text('Ошибка загрузки файла');
                }
            }
        });
    }

    uploadAreaInput
            .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
            })
            .on('dragenter dragover', function () {
                $(this).addClass('is-dragover');
            })
            .on('dragleave dragend drop', function () {
                $(this).removeClass('is-dragover');
            })
            .on('drop', function (e) {
                $(this).removeClass('is-dragover');
                fileUpload(e.originalEvent.dataTransfer.files[0]);
            })
            .on('click', function (f) {
                f.stopPropagation();
                uploadFileInput.focus().trigger('click.input');
            });

    uploadAreaInputPhoto
            .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
            })
            .on('dragenter dragover', function () {
                $(this).addClass('is-dragover');
            })
            .on('dragleave dragend drop', function () {
                $(this).removeClass('is-dragover');
            })
            .on('drop', function (e) {
                $(this).removeClass('is-dragover');
                fileUploadPhoto(e.originalEvent.dataTransfer.files[0]);
            })
            .on('click', function (f) {
                f.stopPropagation();
                uploadFileInputPhoto.focus().trigger('click.input');
            });

    uploadAreaInputSelfie
            .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
            })
            .on('dragenter dragover', function () {
                $(this).addClass('is-dragover');
            })
            .on('dragleave dragend drop', function () {
                $(this).removeClass('is-dragover');
            })
            .on('drop', function (e) {
                $(this).removeClass('is-dragover');
                fileUploadSelfie(e.originalEvent.dataTransfer.files[0]);
            })
            .on('click', function (f) {
                f.stopPropagation();
                uploadFileInputSelfie.focus().trigger('click.input');
            });

    uploadAreaInputSpravka
            .on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
            })
            .on('dragenter dragover', function () {
                $(this).addClass('is-dragover');
            })
            .on('dragleave dragend drop', function () {
                $(this).removeClass('is-dragover');
            })
            .on('drop', function (e) {
                $(this).removeClass('is-dragover');
                fileUploadSpravka(e.originalEvent.dataTransfer.files[0]);
            })
            .on('click', function (f) {
                f.stopPropagation();
                uploadFileInputSpravka.focus().trigger('click.input');
            });

    resultClose.on('click', function (funct) {
        console.log('resultClose.on click');
        uploadAreaResult.hide().attr('style', 'display: none;');
        uploadAreaResult.removeClass('removeClass');
        uploadAreaResult.find('.upload-filename').text('');
        uploadInputFile.val('');
        uploadAreaInput.show();
        svgProgress.removeClass('progress-upload-run progress-upload-end');
        textPercentProgress.html('');
        funct.preventDefault();
        funct.stopPropagation();

        pathFile = [];
        return false;
    });

    resultClosePhoto.on('click', function (funct) {
        console.log('resultClosePhoto.on click');
        uploadAreaResultPhoto.hide().attr('style', 'display: none;');
        uploadAreaResultPhoto.removeClass('removeClass');
        uploadAreaResultPhoto.find('.upload-filename').text('');
        uploadInputFilePhoto.val('');
        uploadAreaInputPhoto.show();
        svgProgressPhoto.removeClass('progress-upload-run progress-upload-end');
        textPercentProgressPhoto.html('');
        funct.preventDefault();
        funct.stopPropagation();

        pathFilePhoto = [];
        return false;
    });

    resultCloseSelfie.on('click', function (funct) {
        console.log('resultCloseSelfie.on click');
        uploadAreaResultSelfie.hide().attr('style', 'display: none;');
        uploadAreaResultSelfie.removeClass('removeClass');
        uploadAreaResultSelfie.find('.upload-filename').text('');
        uploadInputFileSelfie.val('');
        uploadAreaInputSelfie.show();
        svgProgressSelfie.removeClass('progress-upload-run progress-upload-end');
        textPercentProgressSelfie.html('');
        funct.preventDefault();
        funct.stopPropagation();

        pathFileSelfie = [];
        return false;
    });

    resultCloseSpravka.on('click', function (funct) {
        console.log('resultCloseSpravka.on click');
        uploadAreaResultSpravka.hide().attr('style', 'display: none;');
        uploadAreaResultSpravka.removeClass('removeClass');
        uploadAreaResultSpravka.find('.upload-filename').text('');
        uploadInputFileSpravka.val('');
        uploadAreaInputSpravka.show();
        svgProgressSpravka.removeClass('progress-upload-run progress-upload-end');
        textPercentProgressSpravka.html('');
        funct.preventDefault();
        funct.stopPropagation();

        pathFileSpravka = [];
        return false;
    });
    function sendSms(phone) {
        $.ajax({
            url: '/local/scripts/send_sms.php',
            method: 'post',
            data: {
                'phone': phone,
            },
            success: function (result) {
                console.log(result);
            }

        });
    }

    $('#first_step_submit').on('click', function (e) {
        console.log('first_step_submit click locationPage = ' + locationPage);
        e.preventDefault();
        $('.input-error').hide();
        var firstStepBlock = $(this).closest('.first_step_block');
        fio = firstStepBlock.find('input#fio').val();
        phone = firstStepBlock.find('input#phone').val();
        var validation = true;
        switch (locationPage) {
            case '/customer_service/application_forms/':
            {
                fillFieldsForApplicationFormsPage();
                break;
            }
            case '/customer_service/insurance_case/':
            {
                fillFieldsForInsuranceCasePage();
                break;
            }
            case '/customer_service/edit_data/':
            {
                fillFieldsForEditDataPage();
                break;
            }
            default:
            {

            }
        }

        $('.fio_error').hide();
        $('.phone_error').hide();
        console.log(uploadInputFile);
        console.log(pathFile);
        if (uploadInputFile.length && pathFile.length === 0) {
            validation = false;
            $('.input-error-file').text('Прикрепите заполненное заявление');
            $('.input-error-file').show();
            console.log('file');
        }

        if (uploadInputFilePhoto.length && pathFilePhoto.length === 0) {
            validation = false;
            $('.input-error-photo').text('Пожалуйста, прикрепите файл');
            $('.input-error-photo').show();
            console.log('file');
        }

        if (uploadInputFileSelfie.length && pathFileSelfie.length === 0) {
            validation = false;
            $('.input-error-selfie').text('Пожалуйста, прикрепите файл');
            $('.input-error-selfie').show();
            console.log('Selfie');
        }

        if (!/^[ \-а-яА-ЯёЁ\s]+$/.test(fio)) {
            validation = false;
            $('.fio_error').show();
            console.log('fio');
        }
        if (!phone) {
            validation = false;
            $('.phone_error').show();
            console.log('phone');
        }
        if (!firstStepBlock.find('input#is_agree').prop('checked')) {
            validation = false;
            $('.input-error-agree').show();
            console.log('agree');
        }
        console.log('validation', validation);

        if (validation) {
            $('.sms-check__phone span').text(phone);
            $('#declaration_loading').hide();
            $('#sms_confirm').show();
            $('.fbmh-title').addClass('fbmh-title_sms');
            $('.fbmh-title-desktop').text('Подтвердите отправку по СМС');
            $('.fbmh-title-mob').text('Подтверждение по СМС');
            $('#back_button').show();

            var currentStep = $('.form-big-main__header .fbmh-step.fbmh-step__active');

            $('.form-big-main__header .fbmh-step').addClass('fbmh-step__active');
            currentStep.removeClass('fbmh-step__active');

            $([document.documentElement, document.body]).animate({
                scrollTop: $("#form_send_declaration").offset().top
            }, 500);

            //генерация и сохранение смс кода в базу + отправка смс юзеру
            console.log('send sms');
            sendSms(phone);
        }

    });


    function fillFieldsForApplicationFormsPage() {
        reason = $('.select-reason .fsi-dropdown__item[data-checked="1"]').text();
        program = $('.select-program .fsi-dropdown__item[data-checked="1"]').text();
    }
    function fillFieldsForInsuranceCasePage() {
        //insuranceCase = $('.select-insurance_case .fsi-dropdown__item[data-checked="1"]').text();
        whatFace = $('#fbm-step-switcher .alh-switcher__item-active').text().trim();
    }
    function fillFieldsForEditDataPage() {
        change = $('.select-edit_contract .fsi-dropdown__item[data-checked="1"]').text();
    }


    function clearAll() {
        resultClose.trigger('click');
        resultClosePhoto.trigger('click');
        resultCloseSelfie.trigger('click');
        var firstStepBlock = $('#first_step_submit').closest('.first_step_block');
        $('.fbmit_selected_value').val('');
        $('.fbmit_selected_value').closest('.fbm-step-item__input_field').find('.fsi-dropdown__item').attr('data-checked', '0');
        $('#upload_document').hide();
        $('.input-correct').hide();
        firstStepBlock.find('input#fio').val('');
        firstStepBlock.find('input#phone').val('');
        firstStepBlock.find('input#is_agree').prop('checked', true);
        $('#check_sms_code').val('');
        inputChangePhone.val('');
        fio = null;
        phone = null;
        reason = null;
        program = null;
        pathFile = [];
        pathFilePhoto = [];
        pathFileSelfie = [];
        insuranceCase = null;
        change = null;

        $('.form-big-main__header .fbmh-step').removeClass('fbmh-step__active');
        $('.form-big-main__header .fbmh-step').first().addClass('fbmh-step__active');
    }

    function backFirstStep() {
        $('#declaration_loading').show();
        $('#sms_confirm').hide();
        $('#back_button').hide();

        inputChangePhone.val('');
        $('.fbmh-title').removeClass('fbmh-title_sms');
        $('.fbmh-title-desktop').text('Заполнить и отправить заявление');
        $('.fbmh-title-mob').text('Найти заявление');
        $('.sms-check__phone-main').show();
        $('.sms-check__phone-change').hide();
    }

    $('#back_button').on('click', function (e) {
        e.preventDefault();
        backFirstStep();
    });

    $('.sms-check__phone .change-phone').on('click', function (e) {
        e.preventDefault();

        $('.sms-check__phone-main').hide();
        $('.sms-check__phone-change').show();
    });

    $('.send-sms-code').on('click', function (e) {
        e.preventDefault();

        if (inputChangePhone.val() !== '' && inputChangePhone.val() !== null) {
            phone = inputChangePhone.val();
        }
        //генерация и сохранение смс кода в базу + отправка смс юзеру
        console.log('send sms');

        $(this).text('• ');
        setTimeout(function (elem) {
            elem.text(elem.text() + '• ');
        }, 200, $(this));
        setTimeout(function (elem) {
            elem.text(elem.text() + '• ');
        }, 400, $(this));
        setTimeout(function (elem) {
            elem.text('Отправлено');
        }, 600, $(this));

        sendSms(phone);
    });


    $('#check_sms_code').on('input', function () {
        var _this = this;

        if ($(_this).val().length > 0) {
            $('.fbm-step-item__input_title__sms label').show();
        } else {
            $('.fbm-step-item__input_title__sms label').hide();
        }

        if ($(_this).val().length >= 4) {
            //проверка кода

            console.log('check code');
            console.log('insuranceCase', insuranceCase);
            console.log('page', locationPage);
            $.ajax({
                url: '/local/scripts/check_sms_code.php',
                method: 'post',
                data: {
                    'phone': phone,
                    'code': $(this).val(),
                    'fio': fio,
                    'reason': reason,
                    'program': program,
                    'insuranceCase': insuranceCase,
                    'whatFace': whatFace,
                    'change': change,
                    'file': pathFile,
                    'filePhoto': pathFilePhoto,
                    'fileSelfie': pathFileSelfie,
                    'fileSpravka': pathFileSpravka,
                    'page': locationPage
                },
                success: function (result) {
                    console.log(result);
                    if (result === '1') {
                        $(_this).closest('.sms-check__input').find('.input-correct').show();

                        setTimeout(function () {
                            backFirstStep();
                            $('#form_send_declaration').hide();
                            $('#block_info').hide();
                            $('#result_block').find('.fio-result').text(fio);
                            $('#result_block').show();
                        }, 2000);
                        //показ итогового окна
                    }
                }
            });
        }
    });

    $('.cpp-back__text').on('click', function () {
        $('.cpds-step2').hide();
        $('.cpp-fadedtext').html('(шаг 1 из 2)');
        $('.cpp-progress__item').last().removeClass('cpp-progress__item_active');
        $('.cpp-back').hide();
        $('.cpds-step1').show();
    });



    // VALIDATIONS
    function isValidEmail(email) {
        var emailRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailValue = email.find('input').val();

        if (emailValue && emailRegEx.test(emailValue)) {
            email.addClass('feedback__input_right');
            return true;
        } else {
            throw [
                {
                    message: 'Неправильная почта',
                    element: email,
                },
            ];
        }
    }
    function isValidPhone(phone) {
        if (/^\d[\d\(\)\ -]{4,14}\d$/.test(phone.find('input').val())) {
            return true;
        } else {
            throw [
                {
                    message: 'Неправильный номер телефона',
                    element: phone,
                },
            ];
        }
    }
    function isValidPhoneEmail(communication) {
        var phoneRegEx = /^\+?\d[\d\(\)\ -]{4,14}\d$/;
        var emailRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var communicationValue = communication.find('input').val();

        if (phoneRegEx.test(communicationValue) || emailRegEx.test(communicationValue)) {
            communication.addClass('feedback__input_right');
            return true;
        } else {
            throw [
                {
                    message: 'Неправильный номер телефона или почта',
                    element: communication,
                },
            ];
        }
    }
    function isValidPhoneOrEmail(email, phone) {
        var phoneRegEx = /^\+?\d[\d\(\)\ -]{4,18}\d$/;
        var emailRegEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        var emailVal = email.find('input').val();
        var phoneVal = phone.find('input').val();

        if (phoneVal !== "") {
            if (phoneRegEx.test(phoneVal)) {
                console.log(phoneVal);
                return true;
            }
        }

        if (emailVal !== "") {
            if (emailRegEx.test(emailVal)) {
                console.log(emailVal);
                return true;
            }
        }

        if (phoneRegEx.test(phoneVal) || emailRegEx.test(emailVal)) {
            return true;
        } else {
            throw [
                {
                    message: 'Неверный формат почты',
                    element: email,
                },
                {
                    message: 'Неверный формат номера телефона',
                    element: phone,
                },
            ];
        }
    }
    function isValid(text) {
        if (text.find('input, textarea').val().length > 2) {
            text.addClass('feedback__input_right');
            return true;
        } else {
            throw [
                {
                    message: 'Введенное значение слишком короткое',
                    element: text,
                }
            ];
        }
    }
    function isValidName(name) {
        if (/^[ \-а-яА-ЯёЁ\s]+$/.test(name.find('input').val()) && name.find('input').val().trim().length > 1) {
            name.addClass('feedback__input_right');
            return true;
        } else {
            throw [
                {
                    message: 'Неправильныe фамилия, имя или отчество',
                    element: name,
                },
            ];
        }
    }
    function showErrorsOnInput(err) {
        err.forEach(function (errObj) {
            errObj.element.addClass('feedback__input_wrong');
            errObj.element.find('.feedback__input-error').text(errObj.message);
        });

    }
    // VALIDATIONS END

    $('#appeal-to-management').on('submit', function (e) {
        e.preventDefault();

        $('.feedback__input_wrong').removeClass('feedback__input_wrong');
        $('.feedback__input_right').removeClass('feedback__input_right');

        var email = $(this).find("#email");
        var name = $(this).find("#name");
        var phone = $(this).find("#phone");
        var message = $(this).find("#message");

var data = $(this).serialize();
        try {
            if (isValidName(name) && isValidPhoneOrEmail(email, phone) && isValid(message)) {
                if (!$('.feedback-form').find('input#is_agree').prop('checked')) {
                    $('.input-error-agree').show();
                    return;
                }
                /*$('#feedback-form').hide();*/
                $.ajax({
                    url: '/local/scripts/appeal_to_management.php',
                    method: 'post',
                    data: data,
                    success: function (result) {

                        if (result === '1') {
                            $('#appeal-to-management')[0].reset();
                            $('#appeal-to-management').hide();
                            // $('.subtitle_p').html('Спасибо за обращение!<br>В течение 3-х рабочих дней мы проверим заявление и проинформируем вас о дальнейших действиях');
                            $('.feedback__input_right').removeClass('feedback__input_right');
                            $('.feedback_result').show();
                            console.log(result);
                        }

                    }
                });
            }
        } catch (err) {

            showErrorsOnInput(err);
            console.log(err);
        }
    });


    $('#feedbackForm').on('submit', function (e) {
        e.preventDefault();
        $('.feedback__input_wrong').removeClass('feedback__input_wrong');
        $('.feedback__input_right').removeClass('feedback__input_right');

        var name = $(this).find("#name");
        var email = $(this).find("#email");
        var phone = $(this).find("#phone");
        var message = $(this).find("#message");
        var city = $(this).find("#city");
        var ID_FORM = $(this).find("#ID_FORM");
        var program_name = $(this).find("#program_name");
        var program_url = $(this).find("#program_url");
        var program_id = $(this).find("#program_id");
        var callback_time = $(this).find("#callback_time").val();
        var need_whatsapp = 0;
        if ($(this).find("#need_whatsapp").prop('checked')) {
            need_whatsapp = 1;
        }
        //получаем данные из калькулятора на странице продуктов
        var calc = {};
        calc.period = $('#calc .calculator_select_btns_act').text();
        calc.srok = $('.js_result-term').val();
        calc.summa_pri_dostijenii = $('.calculator-result-item-value  .js_calculator_result_value').text();
        calc.summa_per_month = $('.summa_per_month').text();
        calc.summa_za_vesperiod = $('.calc_summ_allperiod span').text();
        calc.summa_edinorazovaia = $('.summ_edinorazovaia').text();
        calc.summa_vozvrata = $('.summa_vozvrata').text();
        calc.summa_vznosa = $('.js_result-now').val();
        calc.summa_spending = $('.js_result-spending').val();

        var utm_campaign, utm_source, utm_medium;

        utm_campaign = $("#utm_campaign").val();
        utm_source = $("#utm_source").val();
        utm_medium = $("#utm_medium").val();

        var promocode = $(this).find(".promocode-input").val();
        var gtm_referrer = $(this).find(".gtm_referrer").val();
        var gtm_client_id = $(this).find(".gtm_client_id").val();
        console.log('send...')
        console.log(utm_campaign)
        try {
            if (isValidName(name) && isValidPhoneOrEmail(email, phone)) {
                if (!$('#feedbackForm').find('input#is_agree').prop('checked')) {
                    $('.input-error-agree').show();
                    console.log('no agree');
                    return;
                }
                console.log('ajax');
                $.ajax({
                    url: '/local/scripts/send_feedback.php',
                    method: 'post',
                    data: {
                        'name': name.find('input').val(),
                        'email': email.find('input').val(),
                        'ID_FORM': ID_FORM.find('input').val(),
                        'phone': phone.find('input').val(),
                        'message': message.find('input, textarea').val(),
                        'city': city.find('input, textarea').val(),
                        'program_name': $(program_name).val(),
                        'program_url': $(program_url).val(),
                        'page_url': window.location.href,
                        'program_id': $(program_id).val(),
                        'calc': calc,
                        'callback_time': callback_time,
                        'need_whatsapp': need_whatsapp,
                        'utm_campaign': utm_campaign,
                        'utm_source': utm_source,
                        'utm_medium': utm_medium,
                        'promocode': promocode,
                        'gtm_referrer': gtm_referrer,
                        'gtm_client_id': gtm_client_id
                    },
                    success: function (result) {
                        $('#feedbackForm')[0].reset();
                        $('#feedbackForm').hide();
                        $('.feedback__input_right').removeClass('feedback__input_right');
                        $('.feedback_result').show();
                        $('.feedback-second-step__btn').show();
                        console.log(result);
                    }
                });
            } else {
                alert('Не все поля заполнены!')

            }
        } catch (err) {
            console.log(err);
            showErrorsOnInput(err);
        }
    });







    $('#finish_button').on('click', function (e) {
        e.preventDefault();
        clearAll();

        switch (locationPage) {
            case '/customer_service/application_forms/':
            {
                $('#result_block').hide();
                $('#form_send_declaration').show();
                $('#block_info').show();
                break;
            }
            case '/customer_service/end_contract_payments/':
            {
                $('#upload_document').show();
                $('#result_block').hide();
                $('.statement-first-screen').show();
                break;
            }
            case '/customer_service/agreement_termination/':
            {
                $('#upload_document').show();
                $('#result_block').hide();
                $('.statement-first-screen').show();
                break;
            }
            case '/customer_service/insurance_case/':
            {
                $('#result_block').hide();
                $('.statement-first-screen').show();
                break;
            }
            case '/customer_service/edit_data/':
            {
                $('#upload_document').show();
                $('#result_block').hide();
                $('.statement-first-screen').show();
                break;
            }
            default:
            {
                console.log('unknown page');
            }

        }

    });

    $('form.back-call-form .send-form').on('click', function (e) {
        e.preventDefault();
        var form = $(this).closest('form.back-call-form');

        if (!$(form).find('input#is_agree').prop('checked')) {
            $('.input-error-agree').show();
            return;
        }
        var fio = form.find('input[name="fio"]').val(),
                phone = form.find('input[name="phone"]').val();

        var validation = true;
        if (!fio) {
            validation = false;
        } else if (!phone) {
            validation = false;
        } else if (!form.find('input#is_agree').prop('checked')) {
            validation = false;
        }
        console.log('validation', validation);

        if (validation) {

            form.find('input[name="fio"]').val('');
            form.find('input[name="phone"]').val('');


            $.ajax({
                url: '/local/scripts/back_call.php',
                method: 'post',
                data: {
                    'fio': fio,
                    'phone': phone
                },
                success: function (result) {
                    console.log(result);
                    $('.back-call-form-wrap').hide();
                    $('.back-call-form-result').show();
                    if (result === '1') {
                        //  form.closest('.ui-modal').find('.ui-modal__close').trigger('click');
                    }

                }
            });
        }

    });


});
